import { graphql, useStaticQuery } from "gatsby";

export const AllFormatsQuery = () => {
	const allFormats = useStaticQuery(graphql`
		query AllFormatsQuery {
			allMarkdownRemark(
				filter: { frontmatter: { templateKey: { eq: "formats" } } }
			) {
				edges {
					node {
						frontmatter {
							title
						}
						id
						fields {
							slug
							language
						}
					}
				}
			}
		}
	`);

	return allFormats;
};
